<template>
    <CompassTableRow
        :expanded="row.subrowsVisible"
        @update:expanded="
            (expandValue) => {
                $emit('update:subrowVisibility', expandValue);
            }
        "
    >
        <CompassTableBodyCell
            v-for="column in columns"
            :key="`objectives-listing-table__table-row-${row.id}-column-${column.code}`"
            :fixed="column.fixed"
            :minWidth="column.width"
            :alignContent="column.alignContent"
        >
            <template v-if="column.code === 'progress'">
                <ProgressBarWithTooltip
                    v-bind="row.progress"
                    class="objectives-listing-table__table-progress-bar"
                />
            </template>
            <template v-else-if="column.code === 'assignee'">
                <AvatarListing v-bind="row.assignee" />
            </template>
            <template v-else>
                {{ row[column.code] }}
            </template>
        </CompassTableBodyCell>

        <CompassTableBodyCell fixed="right" minWidth="48px">
            <CompassMenu
                v-if="row.actions.length > 0"
                trigger="hover"
                placement="left-start"
                customClass="objectives-listing-table__actions-container"
            >
                <CompassIconButton icon="action" size="small" />

                <template slot="dropdown">
                    <CompassMenuItem
                        v-for="(action, index) in row.actions"
                        :key="`objectives-listing-table__table-row-${row.id}-action-${index}`"
                        :disabled="action.disabled"
                        @click="action.onClick"
                    >
                        <CompassTooltip :disabled="!action.disabled" :content="action.tooltip">
                            {{ action.label }}
                        </CompassTooltip>
                    </CompassMenuItem>
                </template>
            </CompassMenu>
        </CompassTableBodyCell>
    </CompassTableRow>
</template>

<script>
import AvatarListing from 'vcomponents/listing/Avatar/AvatarListing.vue';
import ProgressBarWithTooltip from 'vcomponents/listing/ProgressBar/ProgressBarWithTooltip.vue';

export default {
    components: {
        AvatarListing,
        ProgressBarWithTooltip,
    },
    props: {
        row: {
            type: Object,
            required: true,
        },
        columns: {
            type: Array,
            required: true,
        },
    },
};
</script>

<style>
.compass-menu__dropdown__container.objectives-listing-table__actions-container {
    z-index: 5;
}
</style>
